// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d62967a6","453":"6c249f2e","455":"eea71e68","977":"14ef055b"}[chunkId] + ".chunk.js";
};